module.exports = __webpack_public_path__ + "img/instagram.a281e3ff.png";